import React, { useEffect, useRef, useState } from "react";

export const EmbedOverlay = ({ id, selectNode, selected }) => {
  const [isShowing, setIsShowing] = useState(false);

  const timer = useRef(null);

  useEffect(() => {
    if (!selected) {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      setIsShowing(true);
    }
  }, [selected]);

  function hideOverlay() {
    if (timer.current) {
      clearTimeout(timer.current);
    }

    timer.current = setTimeout(() => {
      setIsShowing(false);
    }, 200);
  }

  if (!isShowing) {
    return null;
  }

  return (
    <div
      className="g-embed-overlay"
      onClick={(e) => {
        selectNode(id);
        hideOverlay();
      }}
    ></div>
  );
};
